import Immutable from 'immutable';
import { createMigration } from './utils';

const INHERIT_FROM_TEMPLATE = 'inheritFromTemplate';
const WATERMARK_NONE = 'none';
const DEFAULT_WATERMARK_OPACITY = 0.4;
const DEFAULT_WATERMARK_POSITION = 'top_right';

const initialLandscapeLayout = {
    marginLeft: 100,
    marginTop: 100,
    marginRight: 100,
    marginBottom: 100,
    maxWidth: 176,
    maxHeight: 99,
};


const initialVerticalLayout = {
    marginLeft: 100,
    marginTop: 268.8,
    marginRight: 100,
    marginBottom: 268.8,
    maxWidth: 99,
    maxHeight: 176,
};


const initialSquareLayout = {
    marginLeft: 60,
    marginTop: 60,
    marginRight: 60,
    marginBottom: 60,
    maxWidth: 130,
    maxHeight: 130,
};


export const migrationTo9_158 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
            const currentWatermark = video.get('watermark');
            const watermarkSources = [];
            if (currentWatermark) {
                watermarkSources.push({ sourceData: currentWatermark });
            }
            const template = map.get('template');
            const watermarkOpacity = map.get('watermarkOpacity');
            const watermarkPosition = map.get('watermarkPosition');
            map.set('template', this.migrateTemplate(template, watermarkSources, watermarkOpacity, watermarkPosition));

            map.delete('watermark');
            map.delete('supportsWatermark');
            map.delete('watermarkPosition');
            map.delete('watermarkOpacity');
        });
    },
    migrateTemplate(template, watermarkSources = [], watermarkOpacity = DEFAULT_WATERMARK_OPACITY, watermarkPosition = DEFAULT_WATERMARK_POSITION) {
        return template.withMutations(map => {
            map.set('watermarkSources', watermarkSources);
            const sourceData = watermarkSources.length > 0 ? 'themeRef_watermarkSources_0' : WATERMARK_NONE;
            map.setIn(['watermark', 'sourceData'], sourceData);
            map.setIn(['watermark', 'landscapeLayout'], Immutable.fromJS(initialLandscapeLayout));
            map.setIn(['watermark', 'verticalLayout'], Immutable.fromJS(initialVerticalLayout));
            map.setIn(['watermark', 'squareLayout'], Immutable.fromJS(initialSquareLayout));
            map.setIn(['watermark', 'visible'], true);
            map.setIn(['watermark', 'opacity'], watermarkOpacity);
            map.setIn(['watermark', 'position'], watermarkPosition);
        });
    },
    migrateScene(scene) {
        return scene.withMutations(map => {
            const supportsWatermark = map.get('supportsWatermark');
            if (supportsWatermark) {
                map.setIn(['watermark', 'sourceData'], INHERIT_FROM_TEMPLATE);
            }
            else {
                map.setIn(['watermark', 'sourceData'], WATERMARK_NONE);
            }
            map.setIn(['watermark', 'position'], INHERIT_FROM_TEMPLATE);
            map.delete('supportsWatermark');
        });
    },
});
